import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import Slots from "./Slots";
import logo from "./assets/img/logo.svg";
import bg_mobile from "./assets/img/bg-mobile.jpg";
import bg_table from "./assets/img/bg-table.jpg";
import bg_desktop from "./assets/img/bg_desktop.jpg";
import pay_desk from "./assets/img/payments/pay-desk.png";
import pay_mob from "./assets/img/payments/pay-mob.png";

function App() {
	// let [mainHeight, setHeight] = useState(window.innerHeight);
	// window.addEventListener("resize", () => {
	// 	setHeight(window.innerHeight);
	// 	console.log("123");
	// });
	// useEffect(() => {

	// }, [mainHeight]);
	const xs = useMediaQuery({
		query: "(min-width: 0px) and (max-width: 575.98px)",
	});
	const md = useMediaQuery({
		query: "(min-width: 576px) and (max-width: 767.98px)",
	});
	const lg = useMediaQuery({
		query: "(min-width: 768px) and (max-width: 991.98px)",
	});
	const xl = useMediaQuery({
		query: "(min-width: 992px)",
	});
	const styles = {
		parrents: {
			backgroundImage: `url( ${
				xs ? bg_mobile : md ? bg_table : lg ? bg_table : bg_desktop
			})`,
			backgroundRepeat: "no-repeat",
			backgroundSize: "cover",
			minHeight: "100vh",
			maxHeight: "100vh",
			flexGrow: 1,
			backgroundPositionX: "right",
			display: "flex",
			flexDirection: "column",
		},
		wrapper: {},
		header: {
			display: "flex",
			alignItems: "center",
			paddingLeft: 20,
			paddingRight: 20,
			flexDirection: "column",
			justifyContent: xs ? "normal" : "space-around",
			maxWidth: 1200,
			margin: "25px auto",
			width: "100%",
			boxSizing: "border-box",
			logo: {
				backgroundSize: "contain",
				height: xs ? 20 : 40,
				width: xs ? 80 : 160,
			},
			title: {
				filter: "drop-shadow(0 0 15px black)",
				color: "#fff",
				textShadow: "2px 2px 0 #6f1400",
				textTransform: "uppercase",
				lineHeight: 1,
				paddingLeft: 20,
				fontFamily: "Uni Sans",
				fontStyle: "italic",
				fontWeight: 900,
				textAlign: xs ? "center" : "right",
				fontSize: xs ? 35 : md ? 80 : 70,
				marginTop: xs ? 6 : md ? 10 : 0,
				marginBottom: 15,
			},
		},
		slots: {
			display: "flex",
			// margin: "auto",
			width: "100vw",
			height: "100%",
			flexDirection: "column",
			justifyContent: "center",
			flex: xs ? 0 : 1,
			marginTop: xs ? 50 : 0,
		},
		footer: {
			display: "flex",
			justifyContent: "center",
			maxWidth: 1200,
			margin: "20px auto",
		},
	};

	console.log("xs " + xs);
	console.log("md " + md);
	console.log("lg " + lg);
	console.log("xl " + xl);
	return (
		<div
			style={{
				...styles.parrents,
				// minHeight: window.innerHeight,
				// maxHeight: window.innerHeight,
			}}
		>
			<header style={styles.header}>
				<div
					style={{
						width: "100%",
						// justifyContent: "center",
						display: "flex",
					}}
				>
					<img src={logo} alt="logo" style={styles.header.logo} />
				</div>
			</header>
			<div style={styles.slots}>
				<Slots />
				<footer style={styles.footer}>
					<img
						src={xs ? pay_mob : md ? pay_desk : pay_desk}
						style={{ maxWidth: "100%" }}
						alt="payments"
					/>
				</footer>
			</div>
		</div>
	);
}

export default App;
